
export const Skeleton = ({height = 200,radius = 10}) => {

	return (
		<div
			className="skeleton-bar-chart"
			style={{
				height : height,
				borderRadius : radius
			}}
		>
		</div>
	)
}
